import React from "react";
import PropTypes from "prop-types";
import { Translate } from "react-thunk-i18nify";

import SubscriptionProductIndex from "views/SubscriptionProduct/SubscriptionProductIndex";
import AppSettingIndex from "views/AppSetting/AppSettingIndex";

import {
  TabWithRoute,
  TabRoute,
} from "components/Tab/TabWithRoute/TabWithRoute";

const SettingIndex = ({ match }) => {
  const { url: baseUrl } = match;

  return (
    <TabWithRoute match={match} redirectUrl="app">
      <TabRoute
        resourceName="settings"
        resourcePath="app"
        tabTitle={<Translate value="title.page.appSetting.list" />}
        render={<AppSettingIndex />}
        baseUrl={baseUrl}
      />
      <TabRoute
        resourceName="settings"
        resourcePath="subscription_products"
        tabTitle={<Translate value="title.tab.setting.subscriptionProducts" />}
        render={<SubscriptionProductIndex />}
        baseUrl={baseUrl}
      />
    </TabWithRoute>
  );
};

SettingIndex.defaultProps = {};

SettingIndex.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string,
  }).isRequired,
};

export default SettingIndex;
